import { ModelWithProfileStatusFragment } from "@/generated/graphql-hooks";

export const ModelExperience = ({
  experience,
}: Pick<ModelWithProfileStatusFragment, "experience">) => {
  return (
    <div className="border-secondary rounded-lg border">
      <div>
        <div className="bg-primary rounded-t-lg p-3.5 text-center text-xl text-white">
          KOL 工作經驗
        </div>

        <div className="bg-secondary whitespace-pre-wrap break-words p-3 text-base text-gray-900">
          {experience ?? "尚未新增經歷"}
        </div>
      </div>
    </div>
  );
};
